import { Component, Input, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { ProfessionalService } from 'src/app/services/professional/professional.service';

const HOLD_WINDOW_DAYS = 7;

@Component({
  selector: 'app-payment-onhold-alert',
  templateUrl: './payment-onhold-alert.component.html',
  styleUrls: ['./payment-onhold-alert.component.scss']
})
export class PaymentOnholdAlertComponent implements OnInit, OnChanges, OnDestroy {

  // Pages that already have the current plan's status/hold date on hand (e.g. the magic-link
  // upgrade-payment page, which has no logged-in session to pull professionalService.realtorProfile
  // from) pass source="inputs" plus [status]/[holdStartDate] explicitly, instead of relying on the
  // subscription below. This is an explicit mode flag rather than inferred from whether `status` is
  // defined - inputs arrive asynchronously (after the parent's own API call resolves), so checking
  // "is status defined yet" at ngOnInit time would race and silently pick the wrong mode.
  @Input() source: 'profile' | 'inputs' = 'profile';
  @Input() status?: string;
  @Input() holdStartDate?: string | Date | null;

  showAlert: boolean = false;
  daysLeft: number = 0;
  private subscription: any;

  constructor(private professionalService: ProfessionalService) { }

  ngOnInit(): void {
    if (this.source === 'inputs') {
      this.evaluate(this.status, this.holdStartDate);
      return;
    }

    this.subscription = this.professionalService.realtorProfile.subscribe(value => {
      const plans = value?.b2cProfile?.MembershipPlans;
      const onHoldPlan = plans?.find(plan => plan.IsActive === true && plan.Status === 'OnHold');
      this.evaluate(onHoldPlan ? 'OnHold' : undefined, onHoldPlan?.HoldStartDate);
    });
  }

  ngOnChanges(): void {
    if (this.source === 'inputs') {
      this.evaluate(this.status, this.holdStartDate);
    }
  }

  private evaluate(status: string | undefined, holdStartDate: string | Date | null | undefined): void {
    if (status === 'OnHold' && holdStartDate) {
      const holdStart = new Date(holdStartDate).getTime();
      const today = new Date().getTime();
      const elapsedDays = Math.floor((today - holdStart) / (1000 * 60 * 60 * 24));
      this.daysLeft = Math.max(HOLD_WINDOW_DAYS - elapsedDays, 0);
      this.showAlert = true;
    } else {
      this.showAlert = false;
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
